import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { selectOrgDetails } from 'src/app/store/auth/auth.selector';
import { Organization } from 'src/app/utility/model/organization';
import { environment } from 'src/environments/environment';
import { ContactUsComponent } from './contact-us/contact-us.component';

type FooterUserGuide = {
  lang: string;
  file: string;
};

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  orgDetails: Organization;
  ver = environment.settings.ver;
  @Input() sticky = '';
  @HostBinding('class.sticky') get isSticky() {
    return !!this.sticky;
  }
  showFooterContactUsDialog = environment.settings.showFooterContactUsDialog;
  footerDynamicLogo = environment.settings.footer?.dynamicLogo;
  footerUserGuideLink = environment.settings.footer?.userGuide;
  footerPrivacyLink = environment.settings.footer?.privacyLink;
  footerTnCLink = environment.settings.footer?.tncLink;
  footerLogoLink = environment.settings?.footer?.logoLink || '/home';
  footerFaqLink = environment.settings.footer?.faqLink;
  footerRedemptionGuideLink = environment.settings.footer?.redemptionGuideLink;
  imgUrl = environment.url.img;
  showContactUS = environment.settings.footer?.showContactUS;
  showStaticContactUS = environment.settings.footer?.showStaticContactUS;
  showResource = environment.settings.footer?.showResource;
  showAbout = environment.settings.footer?.showAbout;
  contactEmail = environment.settings.contactEmail;
  contactNumber = environment.settings.contactNumber;
  showFooterOrgText = environment.settings.footer?.showFooterOrgText;
  showAboutRewardz = environment.settings.footer?.showAboutRewardz;
  showVersionAsHeading = environment.settings.footer?.showVersionAsHeading;
  footerTermsOfUseAndPrivacyPolicyLink = environment.settings.appName
    .toLowerCase()
    .includes('cerra')
    ? environment.settings.footer?.termsOfUseAndPrivacyPolicyLink
    : null;

  constructor(
    private store: Store,
    private dialog: MatDialog,
    private router: Router,
  ) {}

  ngOnInit() {
    this.store.pipe(select(selectOrgDetails)).subscribe((orgDetails) => {
      this.orgDetails = orgDetails;
    });
  }

  get year() {
    return new Date().getFullYear();
  }

  openContactUs() {
    if (this.showFooterContactUsDialog) {
      this.dialog.open(ContactUsComponent, {
        maxWidth: '90vw',
        maxHeight: '90vh',
      });
    } else {
      this.router.navigate(['/about/contact-us']);
    }
  }

  isLink(link: FooterUserGuide[] | string | undefined) {
    if (Array.isArray(link)) {
      const link2: FooterUserGuide = link.find(
        (x) => x.lang === localStorage.getItem('lang'),
      );
      return (
        link2?.file.startsWith('https://') || link2?.file.startsWith('assets')
      );
    } else {
      return link?.startsWith('https://') || link?.startsWith('assets');
    }
  }

  get logo2() {
    if (!this.orgDetails?.logo || this.orgDetails?.logo === this.imgUrl + '/') {
      return '';
    }
    return this.orgDetails?.logo.startsWith(this.imgUrl)
      ? this.orgDetails?.logo
      : this.imgUrl + this.orgDetails?.logo;
  }

  get footerUserGuideLink2() {
    if (Array.isArray(this.footerUserGuideLink)) {
      const link: FooterUserGuide = this.footerUserGuideLink.find(
        (x) => x.lang === localStorage.getItem('lang'),
      );
      return link.file;
    } else {
      return this.footerUserGuideLink;
    }
  }
}
